// extracted by mini-css-extract-plugin
export default {"marginLeftResponsive":"BulkReprocess_marginLeftResponsive__oKZun"};